var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { ROOT } from 'app/domains/filesystem';
import { FileSystemEntriesDocument } from './FileSystemEntriesQuery.gql';
export function useFileSystemEntries(variables) {
    const { folderId, sortId, sortOrder, limit, offset } = variables || {};
    const { data, previousData, error, loading, updateQuery, refetch } = useQuery(FileSystemEntriesDocument, {
        fetchPolicy: 'cache-and-network',
        variables: {
            parentId: folderId || ROOT,
            offset,
            limit,
            orderBy: sortId &&
                sortOrder && {
                [sortId]: sortOrder,
            },
        },
    });
    const count = (data === null || data === void 0 ? void 0 : data.count) || 0;
    const _a = data || {}, { entries } = _a, rest = __rest(_a, ["entries"]);
    const tmpEntries = entries || (previousData === null || previousData === void 0 ? void 0 : previousData.entries) || [];
    const filteredEntries = tmpEntries.map((entry) => {
        // eslint-disable-next-line no-underscore-dangle
        if (entry.__typename === 'FileSystemDocument') {
            const { type, marketCode } = entry, document = __rest(entry, ["type", "marketCode"]);
            if (type === 'COMPOSED') {
                return Object.assign({ marketCode, documentType: type }, document);
            }
            return Object.assign({ documentType: type }, document);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return entry;
    });
    return {
        updateEntries: updateQuery,
        error,
        loading,
        refetch,
        data: Object.assign({ entries: filteredEntries, count }, rest),
    };
}
